module.exports = __webpack_public_path__ + "4635a19ed5017bd0ec7cf11995eb917a.png";